import React, { useState, useEffect, useMemo } from "react";
import { Modal, ModalBody, ModalFooter, Spinner } from "reactstrap";
import { OPERATE_MQTT } from "../../../../helpers/socketEvent";
import * as url from "../../../../helpers/url_helper";
import { toast } from "react-toastify";
import { useSocket } from "../../../../Utils/socket";
import Request from "../../../../helpers/request";
import { convertLocalDate } from "../../../../Utils/configController";
import AirHomeLoader from "../../../../components/Common/AirHomeLoader";
import DataTable from "react-data-table-component";
import { Card, CardBody } from "reactstrap";
import { FormatJsonCheckBox } from "../../../../components/Common/button";
export interface modelType {
  headerTitle: string;
  MqttData?: any;
  cancleBtnClick(): void;
}

const MqttBoxModel = ({ headerTitle, MqttData, cancleBtnClick }: modelType) => {
  const socket: any = useSocket();
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  const [debugLogData, setDebugLogData] = useState<any[]>([]);
  const [debugLoading, setDebugLoading] = useState<boolean>(true);
  const [showFormatted, setShowFormatted] = useState<boolean>(false);

  const fetchLogList = () => {
    setDebugLoading(true);
    const reqObj = {
      draw: 1,
      start: 0,
      length: 5,
      search: {
        value: "",
        regex: false,
      },
      slave: MqttData?.slave,
      filterType: 0,
    };

    Request.post(url.DEBUG_DETAIL_LIST, reqObj)
      .then((res) => {
        setDebugLogData(res?.data?.data);
        setDebugLoading(false);
      })
      .catch((err) => {
        console.error("err: ", err);
      });
  };

  useEffect(() => {
    let intervalId: NodeJS.Timeout;

    if (MqttData !== undefined) {
      fetchLogList();

      intervalId = setInterval(() => {
        fetchLogList();
      }, 30000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [MqttData]);

  const handleMQTTData = () => {
    MqttData?.slave
      ? window.open(`/debug-device-details/${MqttData?.slave}`, "_blank")
      : "";
  };

  const handleReload = () => {
    fetchLogList();
  };

  const handleDS = () => {
    if (MqttData !== undefined) {
      const reqObj = {
        slave: MqttData?.slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "DS",
      };

      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleReload();
      toast.success(`DS sent to slave ${MqttData?.slave}`);
    }
  };
  const handleDL = () => {
    if (MqttData !== undefined) {
      const reqObj = {
        slave: MqttData?.slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "DL",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleReload();
      toast.success(`DL sent to slave ${MqttData?.slave}`);
    }
  };
  const handleSS = () => {
    if (MqttData !== undefined) {
      const reqObj = {
        slave: MqttData?.slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "SS",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleReload();
      toast.success(`SS sent to slave ${MqttData?.slave}`);
    }
  };
  const handleReboot = () => {
    if (MqttData !== undefined) {
      const reqObj = {
        slave: MqttData?.slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "HW",
        sub_cmd: "reboot",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleReload();
      toast.success(`Reboot sent to slave ${MqttData?.slave}`);
    }
  };

  const columns = [
    {
      name: "#",
      cell: (_row: any, index: number) => index + 1, // ✅ use `cell` instead of `selector`
      width: "60px",
    },
    {
      name: "Command",
      cell: (row: any) => {
        try {
          const parsed = JSON.parse(row?.command);
          return <div>{parsed.cmd ? parsed.cmd : "-"}</div>;
        } catch (e) {
          return "-";
        }
      },
      wrap: true,
      grow: 0.5,
    },
    {
      name: "TX",
      cell: (row: any) => {
        const isDevice =
          row.topic.includes("/TX") || row.topic.includes("/g2m");
        const content = isDevice
          ? showFormatted
            ? formatCommand(row.command)
            : row.command
          : "-";
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              padding: "10px 2px",
            }}
          >
            {content}
          </div>
        );
      },
      wrap: true,
      grow: 2,
    },
    {
      name: "RX",
      cell: (row: any) => {
        const isMobile =
          row.topic.includes("/RX") || row.topic.includes("/m2g");
        const content = isMobile
          ? showFormatted
            ? formatCommand(row.command)
            : row.command
          : "-";
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              padding: "10px 2px",
            }}
          >
            {content}
          </div>
        );
      },
      wrap: true,
      grow: 2,
    },
    {
      name: "Created At",
      selector: (row: any) => convertLocalDate(row.createdAt),
      wrap: true,
    },
  ];

  const formatCommand = (command: string) => {
    try {
      return JSON.stringify(JSON.parse(command), null, 2);
    } catch {
      return command;
    }
  };
  return (
    <div>
      <Modal
        isOpen={true}
        className="modal-xl"
        style={{
          backgroundColor: "#F7F7FA",
          borderRadius: "12px",
          padding: "0px",
        }}
      >
        <div className="modal-header justify-content-between">
          <div className="d-flex flex-column align-items-center">
            <h5
              className="modal-title"
              id="staticBackdropLabel"
              style={{ textAlign: "center" }}
            >
              {headerTitle}
            </h5>
          </div>
          <div className="d-flex flex-column align-items-center">
            {MqttData?.slave && (
              <h6
                className="modal-title "
                style={{ textAlign: "center", fontSize: "20px" }}
              >
                Slave: {MqttData?.slave}
              </h6>
            )}
          </div>
          <button
            className="btn p-0 d-flex align-items-center"
            style={{
              border: "none",
            }}
            onClick={cancleBtnClick}
            title="Close"
          >
            <box-icon name="x" size="30px"></box-icon>
          </button>
        </div>

        <div
          style={{ backgroundColor: "#F7F7FA" }}
          className="d-flex flex-wrap justify-content-start align-items-center gap-3 p-3  rounded shadow-sm"
        >
          <button className="btn btn-dark" onClick={handleDS}>
            DS
          </button>
          <button className="btn btn-dark" onClick={handleDL}>
            DL
          </button>
          <button className="btn btn-dark" onClick={handleSS}>
            SS
          </button>
          <button className="btn btn-dark" onClick={handleReboot}>
            Reboot
          </button>
        </div>

        <ModalBody style={{ padding: 0 }}>
          <div
            style={{
              maxHeight: "70vh",
              overflowY: "auto",
              overflowX: "auto",
              backgroundColor: "#F7F7FA",
              padding: "20px",
            }}
          >
            <Card>
              <CardBody>
                <div className=" justify-content-between pb-2">
                  <div className="d-flex flex-row justify-content-between align-items-start">
                    <h5
                      className="modal-title"
                      id="staticBackdropLabel"
                      style={{ textAlign: "center" }}
                    >
                      {"Device Details"}
                    </h5>

                    <div className="d-flex align-items-center justify-content-center gap-3">
                      <FormatJsonCheckBox
                        checked={showFormatted}
                        onChange={() => setShowFormatted(!showFormatted)}
                      />
                      <button
                        className="btn btn-dark btn-sm d-flex align-items-center justify-content-center p-1"
                        onClick={handleReload}
                        disabled={debugLoading}
                        title="Refresh"
                        aria-label="Refresh"
                        type="button"
                      >
                        <box-icon
                          name="refresh"
                          size="18px"
                          animation={debugLoading ? "spin" : ""}
                          color="white"
                        ></box-icon>
                      </button>
                    </div>
                  </div>
                </div>
                {debugLoading && <AirHomeLoader />}
                <DataTable
                  columns={columns}
                  data={debugLogData}
                  noDataComponent="No records found."
                  customStyles={customStyles}
                  highlightOnHover
                />
                <div
                  className="d-flex justify-content-center align-items-center mt-2"
                  style={{ width: "100%" }}
                >
                  {MqttData?.slave && (
                    <button
                      onClick={() => handleMQTTData()}
                      style={{
                        border: "none",
                        outline: "none",
                        background: "none",
                      }}
                    >
                      <span
                        className="badge bg-primary"
                        style={{
                          height: "25px",
                          fontSize: "12px",
                          padding: "6px",
                        }}
                      >
                        More Logs
                      </span>
                    </button>
                  )}
                </div>
              </CardBody>
            </Card>
          </div>
        </ModalBody>

        <ModalFooter
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <button
            className="btn btn-outline-secondary"
            onClick={cancleBtnClick}
            style={{ marginLeft: "auto" }}
          >
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default MqttBoxModel;
export const customStyles: any = {
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "0px solid #ced4da", // header bottom border
    },
  },
};
